import { render, staticRenderFns } from "./TableSetWidthColumn.vue?vue&type=template&id=3ea7f97c"
import script from "./TableSetWidthColumn.vue?vue&type=script&lang=js"
export * from "./TableSetWidthColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports